import { useState, useEffect } from 'react';
import { useUserContext } from '../../../hooks/useUserContext';
import { useTranslation } from 'react-i18next';
import ImageMap from '../../welten/ImageMap';
import "./BeteiligungFamilie.css";

export default function BeteiligungFamilie({oldAndNewScore}) {
    const { t } = useTranslation();
    //variables for score and state updating
    const { games, updateGames, calculateScore, score, language } = useUserContext();
    const beteiligung_familie = games.beteiligung_familie;
    const max_points = games.beteiligung_familie.points_max;

    //set up image map variables
    var imgSrc;
    switch(language) {
      case 'de':
        imgSrc = "beteiligung_familie.png";
        break;
      case 'fr':
        imgSrc = "beteiligung_familie_fr.png";
        break;
      case 'it':
        imgSrc = "beteiligung_familie_it.png";
        break;
    }
    const height = window.innerHeight*0.6;
    const imgWidth = (height/1969)*3891;
    const viewbox = "0 0 " + imgWidth.toString() + " " + height.toString();
    const factor = height/1969;
    const imgMap = {
        imgSrc: imgSrc,
        areas: [
          {
            id: 1,
            name: 'nope',
            type: 'rect',
            x: 219,
            y: 0,
            width: 794,
            height: 418,
          },
          {
            id: 2,
            name: 'beteiligung_familie1',
            type: 'rect',
            x: 4,
            y: 1047,
            width: 794,
            height: 418,
          },
          {
            id: 3,
            name: 'beteiligung_familie2',
            type: 'rect',
            x: 939,
            y: 683,
            width: 794,
            height: 418,
          },
          {
            id: 4,
            name: 'nope',
            type: 'rect',
            x: 1162,
            y: 1551,
            width: 794,
            height: 418,
          },
          {
            id: 5,
            name: 'nope',
            type: 'rect',
            x: 1922,
            y: 105,
            width: 794,
            height: 418,
          },
          {
            id: 6,
            name: 'beteiligung_familie3',
            type: 'rect',
            x: 2135,
            y: 1002,
            width: 794,
            height: 418,
          },
          {
            id: 7,
            name: 'beteiligung_familie4',
            type: 'rect',
            x: 2982,
            y: 232,
            width: 794,
            height: 418,
          },
          {
            id: 8,
            name: 'beteiligung_familie5',
            type: 'rect',
            x: 3094,
            y: 1399,
            width: 794,
            height: 418,
          }
        ],
    }

    const [wimmelbilder, setWimmelbilder] = useState({
        beteiligung_familie1: false,
        beteiligung_familie2: false,
        beteiligung_familie3: false,
        beteiligung_familie4: false,
        beteiligung_familie5: false
    });

    const [text, setText] = useState(t('beteiligung_familie.start_text'));

    const clicked = (event, name) => {
        if (name!=="nope") {
            setWimmelbilder(wimmelbilder => ({...wimmelbilder, [name]: true}));
            event.target.id="active";
            show_message("good");
        } else if (name === "nope") {
            event.target.id="wrong";
            show_message("bad");
        };
        
    };

    const [wimmelbild_msg, setWimmelbildMsg] = useState("");
    const show_message = (state) => {
        if (state === "good") {
            setWimmelbildMsg(t('beteiligung_familie.correct'));
        } else if (state === "bad") {
            setWimmelbildMsg(t('beteiligung_familie.wrong'));
        };
        document.getElementById("wimmelbild_message").style.display = "flex";
        setTimeout(() => document.getElementById("wimmelbild_message").style.display="none", 1000);
    };

    useEffect(() => {
        let finished_temp = true;
        for (const value of Object.values(wimmelbilder)) {
            if (value === false) {
                finished_temp = false;
            };
        };
        if (finished_temp === true) {
            setText(t('beteiligung_familie.finish_text'));
            const beteiligung_familie_new = { ...beteiligung_familie, state: 'done', points_achieved: max_points };
            const games_new = { ...games, beteiligung_familie: beteiligung_familie_new };
            updateGames(games_new);
            const current_game = "beteiligung_familie";
            let total_score = calculateScore(current_game);
            total_score += max_points;
            const oldScore = score;
            const newScore = total_score;
            oldAndNewScore(oldScore, newScore);
            //updateScore(total_score);
            setTimeout(() => {
                setWimmelbildMsg(t('beteiligung_familie.finished'));
                document.getElementById("wimmelbild_message").style.display="flex";
                }
                , 1500);
        };
    },[wimmelbilder]);

    return (
        <div className="wimmelbild">
            <h2>{text}</h2>
            <div className="wrapper_wimmelbild" style={{ width: "100%", height: "65vh", overflowX: "auto", overflowY: "auto" }}>
                <ImageMap clicked={clicked} factor={factor} imgWidth={imgWidth} viewbox={viewbox} height={height} imgMap={imgMap} folder="game"/>
            </div>
            <div className="wimmelbild_message" id="wimmelbild_message">
                <p>{wimmelbild_msg}</p>
            </div>
        </div>
    )
}